import { render } from "./AlarmmessagesForPlant.vue?vue&type=template&id=2f4ed2a0"
import script from "./AlarmmessagesForPlant.vue?vue&type=script&lang=js"
export * from "./AlarmmessagesForPlant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__